import { ServiceDropdownWUT } from '@wix/form-fields/wut';

export default ServiceDropdownWUT;
